<template>
  <div class="product-wrap">
    <div class="outer">
      <div class="content">
        <img :src="content">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    content() {
      return require(`@/assets/images/products/2-${this.$i18n.locale}.png`);
    }
  }
};
</script>
<style lang="stylus" scoped>
.product-wrap {
  margin-top: -2.6em;
  background-color: #f8f8f8;

  .outer {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    .content {
      width: 100%;

      img {
        display: block;
        margin: 0 auto;
        width: 80%;
      }
    }
  }
}
</style>
